import { render } from "./Banner.vue?vue&type=template&id=4cdfbd1c&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=4cdfbd1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdfbd1c"]])

export default __exports__